import { SignOut } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';

import { cn } from '../../utils/cn';
import pt from '../../locales/pt';
import { paths } from '../../routes/paths';
import { useAuth } from '../../store/AuthContext';

/**
 * `ds/nav/sidebar-logout` — linha de Sair partilhada pela sidebar desktop e
 * pelo drawer de navegação: gap $space-2, padding [$space-2, $space-3],
 * radius $radius-ds-md, ícone 16, label $type-body-sm normal em $fg-muted.
 */
export function AppNavLogout({ className, onAfterLogout, compact = false }) {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    onAfterLogout?.();
    await logout();
    navigate(paths.signIn, { replace: true });
  };

  return (
    <button
      type="button"
      onClick={handleLogout}
      data-ds-id="ds/nav/sidebar-logout"
      className={cn(
        'flex w-full items-center gap-space-2 rounded-ds-md px-space-3 py-space-2 text-type-body-sm font-normal text-muted-foreground transition-colors hover:bg-muted hover:text-foreground',
        !compact && 'gap-space-3 text-type-body',
        className,
      )}
    >
      <SignOut className="h-4 w-4 shrink-0" aria-hidden />
      {pt.common.logout}
    </button>
  );
}
